import request from '@/utils/request'
import { baseUrl1,baseUrl3} from "./baseUrl"; 
import qs from 'qs'
//聊天中的简历项目内容；
export function getChatInfo(params) {
    return request({
        url: baseUrl3 + '/api/chat/getChatInfo',
        method: 'post',
        data: qs.stringify(params),
    })
}
//保存微信号
export function updateUserWeChat(params) {
    return request({
        url: baseUrl1 + '/api/user/updateUserWeChat',
        method: 'post',
        data: qs.stringify(params),
    })
}

//简历投递
export function getResumeMailingList(params) {
    return request({
        url: baseUrl3 + '/api/resumeMailing/getResumeMailingList',
        method: 'post',
        data: params,
    })
}



// WEBPACK FOOTER //
// ./src/api/chat.js